export type IDiscountTileV3Resources = typeof DiscountTileV3Resources;

export const DiscountTileV3Resources = {
    flyerLabel: "Nowa Gazetka",
    discountType: {
        Dedicated: "Zniżka",
        Promotion: "Zniżka",
        Sale: "WYPRZEDAŻ",
        New: "Nowość",
        Event: "Wydarzenie",
        Flyer: "Gazetka",
    },
    accessibility: {
        brand: "Sklep",
    },
};
